import React from "react";
import Typography from "aldoo-ra/Typography";

/**
 * FieldTypeSelector Component
 * Allows selection of a field type for creating new fields
 */
const FieldTypeSelector = ({
  value,
  onChange,
  label,
  required = false,
  error,
  placeholder = "Select field type",
  variant = "admin"
}) => {
  // Available field types
  const fieldTypes = [
    { value: 'text', label: 'Text' },
    { value: 'longtext', label: 'Long Text' },
    { value: 'number', label: 'Number' },
    { value: 'boolean', label: 'Boolean' },
    { value: 'date', label: 'Date' },
    { value: 'image', label: 'Image' },
    { value: 'file', label: 'File' },
    { value: 'select', label: 'Select' },
    { value: 'multiselect', label: 'Multi-Select' },
    { value: 'reference', label: 'Reference' },
    { value: 'json', label: 'JSON' },
  ];

  return (
    <div>
      {label && (
        <Typography variant="admin_label" className="mb-1">
          {label}
          {required && <span className="text-admin_error ml-1">*</span>}
        </Typography>
      )}

      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        variant={variant}
        className="w-full"
      >
        <option value="">{placeholder}</option>
        {fieldTypes.map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </select>

      {error && (
        <Typography variant="admin_caption" className="text-admin_error mt-1">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default FieldTypeSelector;
